<script>
const createComponent = (vm, dNode, h) => {
  // Handle empty elements and return empty array in case the dNode passed in is empty
  if (vm._isEmpty(dNode)) {
    return []
  }

  // if the el is array call createComponent for all elements
  if (vm._isArray(dNode)) {
    return dNode.map((child) => createComponent(vm, child, h))
  }

  let children = []

  // svgson output special -> put text child value to parent value
  if (dNode.children && dNode.children.length === 1 && dNode.children[0].type === 'text') {
    dNode.value = vm._clone(dNode.children[0].value)
    dNode.children = []
  }

  if (dNode.children && dNode.children.length > 0) {
    dNode.children.forEach((c) => {
      if (vm._isString(c)) {
        children.push(c)
      } else {
        children.push(createComponent(vm, c, h))
      }
    })
  }

  const attributes = vm._cloneDeep(dNode.attributes)
  const properties = { attrs: attributes }

  // Add event handlers
  if (attributes.cab) {
    attributes.class = attributes.class || ''
    dNode.attributes['tooltip-text'] = ''
    const parsedCab = attributes.cab.substring(0, 1) === '0' ? attributes.cab : parseInt(attributes.cab);

    // cabin room node
    if (attributes.id.substring(0, 2) === 'r_') {
      // available cabin in this category
      if (vm._find(vm.catCabins, { unit: parsedCab })) {
        let cab = vm._find(vm.catCabins, { unit: parsedCab })
        attributes.class += ' cab-on'

        if (cab.isAgencyKontingent) {
          // attributes.class += ' cab-agency'
        }

        // available cabin in other category
      } else if (vm._find(vm.allCabins, { unit: parsedCab })) {
        attributes.class += ' cab-other'

        // unavailable cabin
      } else {
        attributes.class += ' cab-off'
      }
    }

    // cabin number node
    if (attributes.id.substring(0, 2) === 'n_') {
      // available cabin in this category
      if (vm._find(vm.catCabins, { unit: parsedCab })) {
        let cab = vm._find(vm.catCabins, { unit: parsedCab })
        attributes.class += ' cabno-on'

        if (cab.isAgencyKontingent) {
          attributes.class += ' cabno-agency'
        }

        // available cabin in other category
      } else if (vm._find(vm.allCabins, { unit: parsedCab })) {
        attributes.class += ' cabno-other'

        // unavailable cabin
      } else {
        attributes.class += ' cabno-off'
      }
    }

    properties.on = {
      click: ($event) => {
        vm.handleClick($event)
      },
      mouseenter: ($event) => {
        vm.handleMouseEnter($event)
      },
      mouseleave: ($event) => {
        vm.handleMouseLeave($event)
      }
    }
  }
  return h(dNode.name, properties, children.length > 0 ? children : dNode.value)
}

export default {
  name: 'Deckplan',
  render (h) {
    return createComponent(this, this.nodes, h)
  },
  props: {
    nodes: {
      type: Object,
      required: true
    },
    catCabins: {
      type: Array,
      required: true
    },
    allCabins: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    },
    handleMouseEnter (evt) {
      this.$emit('mouseenter', evt)
    },
    handleMouseLeave (evt) {
      this.$emit('mouseleave', evt)
    }
  }
}
</script>

<style scoped>
.cab-off {
  fill: #fff;
}
.cab-other {
  fill: #fff;
  cursor: pointer;
}
.cab-on {
  cursor: pointer;
}
.cabno-off {
  fill: #888;
}
.cabno-other {
  cursor: pointer;
}
.cabno-on {
  cursor: pointer;
}
.cab-agency {
  fill: #8ab5cc;
}
.cabno-agency {
  fill: #fff;
}
</style>
